<footer class="footer">
    <div class="frow-container">
        <div class="frow row-between items-start">
            <div class="logo frow centerd">
                <div class="mr-30">
                    <a class="mr-30" href="https://omgidrawedit.com">&copy; 2021 OMGIDRAWEDIT</a>
                    <p>ILLUSTRATED BY GEORGE GOODWIN</p>
                </div>
            </div>
            <!-- <div class="links frow centered">
                <a class="mr-30">About</a>
                <a class="mr-30">Faq</a>
                <a class="mr-30">Roadmap</a>
            </div> -->
        </div>
    </div>
</footer>